// <auto-generated/>
// Sourced from the repository-local generator baseline at:
// fhir-codegen\generated\TypeScript_R4.ts
import * as fhir from '../fhir'

/**
 * A task to be performed.
 */
export type ITask = fhir.IDomainResource & {
  /**
   * Resource Type Name
   */
  resourceType: "Task";
  /**
   * The healthcare event during which this task was created.
   */
  encounter?: fhir.IReference|undefined;
  /**
   * The entity who benefits from the performance of the service specified in the task.
   */
  for?: fhir.IReference|undefined;
  /**
   * Additional information that may be needed in the execution of the task.
   */
  input?: fhir.IBackboneElement[]|undefined;
  /**
   * In most cases, Tasks will have an intent of order.
   */
  intent: TaskIntentEnum|null;
  _intent?: fhir.IFhirElement|undefined;
  /**
   * The current status of the task.
   */
  status: TaskStatusEnum|null;
  _status?: fhir.IFhirElement|undefined;
}

/**
 * A task to be performed.
 */
export class Task extends fhir.DomainResource implements fhir.ITask {
  /**
   * Resource Type Name
   */
  public override resourceType: "Task";
  /**
   * The healthcare event during which this task was created.
   */
  public encounter?: fhir.Reference|undefined;
  /**
   * The entity who benefits from the performance of the service specified in the task.
   */
  public for?: fhir.Reference|undefined;
  /**
   * Additional information that may be needed in the execution of the task.
   */
  public input?: fhir.BackboneElement[]|undefined;
  /**
   * In most cases, Tasks will have an intent of order.
   */
  public intent: TaskIntentEnum|null;
  public _intent?: fhir.FhirElement|undefined;
  /**
   * The current status of the task.
   */
  public status: TaskStatusEnum|null;
  public _status?: fhir.FhirElement|undefined;

  /**
   * Default constructor for Task - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ITask> = {}) {
    super(source);
    this.resourceType = 'Task';
    if (source["encounter"]) { this.encounter = new fhir.Reference(source.encounter!); }
    if (source["for"]) { this.for = new fhir.Reference(source.for!); }
    if (source["input"]) { this.input = source.input.map((x:Partial<fhir.IBackboneElement>) => new fhir.BackboneElement(x)); }
    this.intent = null;
    if (source["intent"]) { this.intent = source.intent; }
    if (this.intent === undefined) { this.intent = null }
    if (source["_intent"]) { this._intent = new fhir.FhirElement(source._intent!); }
    this.status = null;
    if (source["status"]) { this.status = source.status; }
    if (this.status === undefined) { this.status = null }
    if (source["_status"]) { this._status = new fhir.FhirElement(source._status!); }
  }

  /**
   * Check if the current Task contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    if (this["intent"] === undefined) { missingElements.push("intent"); }
    if (this["status"] === undefined) { missingElements.push("status"); }
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }

  /**
   * Factory function to create a Task from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ITask):Task {
    var dest:Task = new Task(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Task is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}

/**
 * Code Values for the Task.intent field
 */
export enum TaskIntentEnum {
  UNKNOWN = "unknown",
  PROPOSAL = "proposal",
  PLAN = "plan",
  ORDER = "order",
  ORIGINAL_ORDER = "original-order",
  REFLEX_ORDER = "reflex-order",
  FILLER_ORDER = "filler-order",
  INSTANCE_ORDER = "instance-order",
  OPTION = "option",
}

/**
 * Code Values for the Task.status field
 */
export enum TaskStatusEnum {
  DRAFT = "draft",
  REQUESTED = "requested",
  RECEIVED = "received",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  READY = "ready",
  CANCELLED = "cancelled",
  IN_PROGRESS = "in-progress",
  ON_HOLD = "on-hold",
  FAILED = "failed",
  COMPLETED = "completed",
  ENTERED_IN_ERROR = "entered-in-error",
}